module.exports = __webpack_public_path__ + "media/packs/images/flags/IL-1d959b71b490e094cf55d91c435152f2.png";